import React from 'react';
import { Route } from 'react-router-dom';
import AppLayout from './AppLayout';
import Home from './pages/Home';
import FreeTastePage from './pages/FreeTastePage';

export const appRoutes = (
  <Route element={<AppLayout />}>
    <Route path="/" element={<Home />} />
    <Route path="/free-taste" element={<FreeTastePage />} />
  </Route>
);
